const contentMenuData =
[
  {
    title: '틴즈 경제 뉴스관리',
    id: 'TEENS_ECONOMIC_NEWS',
    menuIcon: '📡',
    routerPath: 'CONTENT_TEENS_ECONOMIC_NEWS_LIST',
  },
]
export { contentMenuData }